import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import { sdk } from "./medusa"
import { MESSAGE_BY_KEY, render } from "./message-defaults"

export * from "./message-defaults"

/**
 * The owners' own wording for HQ's ready messages (lib/message-defaults.ts has every message and
 * HQ's wording), kept on the server and shared by everyone who signs in.
 */
type Saved = { templates: Record<string, string>; updated_at: string | null }

export function useMessageTemplates() {
  const queryClient = useQueryClient()
  const saved = useQuery({ queryKey: ["hq", "messages"], queryFn: () => sdk.client.fetch<Saved>("/admin/hq/settings/messages"), staleTime: 5 * 60_000 })
  const save = useMutation({
    mutationFn: (body: { key: string; text: string | null }) => sdk.client.fetch<{ templates: Record<string, string> }>("/admin/hq/settings/messages", { method: "POST", body }),
    onSuccess: (answer) => queryClient.setQueryData(["hq", "messages"], (before: Saved | undefined) => ({ templates: answer.templates, updated_at: before?.updated_at ?? null })),
  })
  const own = saved.data?.templates ?? {}
  /** The wording in force for a message: the owners' own, else HQ's. */
  const template = (key: string) => own[key] ?? MESSAGE_BY_KEY.get(key)?.text ?? ""
  /** A message filled in for one order. */
  const message = (key: string, vars: Record<string, string | number | null | undefined>) => render(template(key), vars)
  return { template, message, own, loaded: !saved.isLoading, save }
}
